import { fetchingData } from "../api";

const Pagination = (props) => {
  const { links, onChange } = props;

  if (links && links.length > 0) {
    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination">
          {links.map((i, index) => {
            return (
              <li
                key={index}
                className={i.active ? "page-item bg-primary-3 rounded" : "page-item"}
              >
                <button
                  onClick={() => {
                    if (i.url) {
                      let page = i.url.split("?page=");
                      page = page[1];
                      onChange(page);
                      fetchingData();
                    }
                    // }} className="page-link" dangerouslySetInnerHTML={{__html: i.label}}></button>
                  }}
                  className="page-link bg-none text-gray-400 rounded border-0"
                >
                  {(() => {
                    if (i.label === "&laquo; Previous") {
                      return <span aria-hidden="true">&laquo;</span>;
                    } else if (i.label === "Next &raquo;") {
                      return <span aria-hidden="true">&raquo;</span>;
                    } else {
                      return i.label;
                    }
                  })()}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  } else {
    return '';
  }
};

export default Pagination;
